import React from 'react'
import PropTypes from 'prop-types'
import styles from './EditUser.scss'
import { Link } from 'react-router-dom'
import { Breadcrumb, BreadcrumbItem, Container, Button, Row, Col, Form, FormGroup, Input, Label, Badge } from 'reactstrap'

const EditUser = props =>
  <Container className={styles.EditUser}>
    <div>
      <Breadcrumb>
        <BreadcrumbItem><Link to='/'>Home</Link></BreadcrumbItem>
        <BreadcrumbItem><Link to='/users'>Users</Link></BreadcrumbItem>
        <BreadcrumbItem active>{props.userId ? (props.firstName + ' ' + props.lastName).trim() : 'New User'}</BreadcrumbItem>
      </Breadcrumb>
    </div>

    <Row>
      <Col xs='10'><h3>{props.userId ? 'Edit' : 'New'} User</h3></Col>
      <Col xs='2' className='text-right'><Badge className='ml-2'>{props.isSaving ? 'Saving' : ''}</Badge></Col>
    </Row>

    <Form>
      <FormGroup row>
        <Label for='email' sm={2}>Email</Label>
        <Col sm={10}>
          <Input id='email' type='email' placeholder='Email' onChange={(e) => props.onChange(e, 'email')} value={props.email} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for='firstName' sm={2}>First Name</Label>
        <Col sm={10}>
          <Input id='firstName' placeholder='First Name' onChange={(e) => props.onChange(e, 'firstName')} value={props.firstName} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for='lastName' sm={2}>Last Name</Label>
        <Col sm={10}>
          <Input id='lastName' placeholder='Last Name' onChange={(e) => props.onChange(e, 'lastName')} value={props.lastName} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for='password' sm={2}>Password</Label>
        <Col sm={10}>
          <Input id='password' type='password' placeholder='Password' onChange={(e) => props.onChange(e, 'password')} value={props.password} />
        </Col>
      </FormGroup>
      <FormGroup row>
        <Label for='passwordConfirm' sm={2}>Password Confirm</Label>
        <Col sm={10}>
          <Input id='passwordConfirm' type='password' placeholder='Password Confirm' onChange={(e) => props.onChange(e, 'passwordConfirm')} value={props.passwordConfirm} />
        </Col>
      </FormGroup>

      <Row>
        <Col sm={{ size: 6, push: 2, pull: 2, offset: 3 }}>
          <Button color='secondary' onClick={props.onCancel}>Cancel</Button>{' '}
          <Button color='primary' onClick={props.onSave}>Save</Button>
        </Col>
      </Row>
    </Form>
  </Container>

EditUser.propTypes = {
  userId: PropTypes.number,
  email: PropTypes.string,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  password: PropTypes.string,
  passwordConfirm: PropTypes.string,
  isSaving: PropTypes.boolean,
  onChange: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
}

export default EditUser



// WEBPACK FOOTER //
// ./src/pages/EditUser/EditUser.js